import React, { useState, useEffect } from "react";
import { Form, Input, Button, message, Spin } from 'antd';
import { LockOutlined, MailOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import '../../assets/css/LoginForm.css';
import Api from '../api/Api';

const LoginForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  // Configuração das partículas
  const particlesInit = async (engine) => {
    await loadSlim(engine);
  };

  const particlesOptions = {
    background: {
      color: {
        value: "transparent",
      },
    },
    fpsLimit: 60,
    interactivity: {
      events: {
        onClick: {
          enable: true,
          mode: "push",
        },
        onHover: {
          enable: true,
          mode: "repulse",
        },
        resize: true,
      },
      modes: {
        push: {
          quantity: 4,
        },
        repulse: {
          distance: 100,
          duration: 0.4,
        },
      },
    },
    particles: {
      color: {
        value: "#ffffff",
      },
      links: {
        color: "#ffffff",
        distance: 150,
        enable: true,
        opacity: 0.3,
        width: 1,
      },
      move: {
        direction: "none",
        enable: true,
        outModes: {
          default: "bounce",
        },
        random: false,
        speed: 2,
        straight: false,
      },
      number: {
        density: {
          enable: true,
          area: 800,
        },
        value: 60,
      },
      opacity: {
        value: 0.5,
      },
      shape: {
        type: "circle",
      },
      size: {
        value: { min: 1, max: 3 },
      },
    },
    detectRetina: true,
  };

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'Enter' && !loading) {
        form.submit();
      }
    };
    
    window.addEventListener('keypress', handleKeyPress);
    return () => window.removeEventListener('keypress', handleKeyPress);
  }, [loading, form]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const costumerData = {
        email: values.email,
        password: values.password,
      };
      
      const result = await Api.Login(costumerData);
      
      if (result.success) {
        message.success({
          content: 'Login realizado com sucesso!',
          style: {
            marginTop: '20vh',
          },
        });
        
        localStorage.setItem('user', JSON.stringify(result.user));
        localStorage.setItem('token', result.token || '');
        
        setTimeout(() => {
          navigate('/Home');
        }, 800);
      } else {
        message.error({
          content: 'E-mail ou senha inválidos.',
          style: {
            marginTop: '10vh',
          },
        });
      }
    } catch (error) {
      message.error({
        content: `Erro ao fazer login: ${error.message}`,
        style: {
          marginTop: '10vh',
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-container">
      {/* Partículas de fundo */}
      <Particles
        id="particles-js"
        init={particlesInit}
        options={particlesOptions}
      />
      
      <div className="login-form-container">
        <div className="login-title">
          <h2>Bem-vindo</h2>
          <p style={{ color: '#666', fontSize: '14px' }}>
            Entre com suas credenciais para continuar
          </p>
        </div>
        
        <Form
          form={form}
          name="login_form"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          className="login-form"
          disabled={loading}
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Por favor, insira seu e-mail!' },
              { type: 'email', message: 'Por favor, insira um e-mail válido!' }
            ]}
          >
            <Input
              prefix={<MailOutlined style={{ color: '#667eea' }} />}
              placeholder="E-mail"
              size="large"
              autoComplete="email"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Por favor, insira sua senha!' }]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: '#667eea' }} />}
              placeholder="Senha"
              size="large"
              autoComplete="current-password"
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              size="large"
              icon={loading ? null : <ArrowRightOutlined />}
              className="login-form-button"
              style={{ 
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
            >
              {loading ? <Spin size="small" /> : 'Acessar Sistema'}
            </Button>
          </Form.Item>

          <div className="login-links">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate('/forgot-password');
              }}
            >
              Esqueceu a senha?
            </a>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate('/register');
              }}
            >
              Criar nova conta
            </a>
          </div>

          <div style={{ 
            marginTop: 25, 
            textAlign: 'center',
            fontSize: '12px',
            color: '#9ca3af'
          }}>
            <p>© Todos os direitos reservados.</p>
            <p style={{ marginTop: 5 }}>
              Versão 1.0.1
            </p>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default LoginForm;